Ply.AllocationWizardSelectionStep = function(el, options) {
    Ply.AllocationWizardStep.call(this, el, options);

    this.initSelectButton = this.initSelectButton.bind(this);
    this.handleSelectButtonClick = this.handleSelectButtonClick.bind(this);

    this.buttons = Ply.makeArray(this.dom.el.querySelectorAll("[data-allocation-select]")).map(this.initSelectButton);
};

Ply.AllocationWizardSelectionStep.prototype = Object.create(Ply.AllocationWizardStep.prototype);
Ply.AllocationWizardSelectionStep.prototype.constructor = Ply.AllocationWizardSelectionStep;

Ply.AllocationWizardSelectionStep.prototype.render = function() {
    this.buttons.forEach(function(button, i) {
        button.render();
    });
    Ply.AllocationWizardStep.prototype.render.call(this);
};

Ply.AllocationWizardSelectionStep.prototype.initSelectButton = function(el, i) {
    return new Ply.AllocationSelectButton(el, {
        props: this.options.props,
        onClick: this.handleSelectButtonClick
    });
};

Ply.AllocationWizardSelectionStep.prototype.handleSelectButtonClick = function(event) {
    this.disableButtons();
    event.target.innerHTML = this.buttonSubmittingText();
    this.options.onSelectButtonClick(event);
};
